import { render } from "./TalentManagementComponent.vue?vue&type=template&id=3b658061&scoped=true"
import script from "./TalentManagementComponent.vue?vue&type=script&lang=js"
export * from "./TalentManagementComponent.vue?vue&type=script&lang=js"

import "./TalentManagementComponent.vue?vue&type=style&index=0&id=3b658061&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b658061"]])

export default __exports__